import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const AboutUsRoutes: RouteRecordRaw = {
  path: '/about-us',
  name: 'AboutUsModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageAboutUsRoute',
      component: () => import('./views/ManageAboutUsView.vue'),
      meta: {
        title: 'درباره ما',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.aboutUs,
  },
}

export default (router: Router) => {
  router.addRoute(AboutUsRoutes)
}
